/* eslint-disable react/no-array-index-key */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-underscore-dangle */
import React, { useState, useRef, useContext } from 'react';
import { CheckCircleIcon } from '@heroicons/react/solid';
import { Context as AuthContext } from 'contexts/auth';
import { resourceRequest } from 'api/client/requests';
import { DataColumn } from './dataColumn';
import { ConfirmationDialog, ConfirmationDialogTypes } from './confirmationDialog';
import { LinkColumn } from './linkColumn';
import { Pagination } from './pagination';
import { EditDataColumn } from './editDataColumn';

export const List = ({
  source,
  keyField,
  // totalItems,
  // pagable,
  // currentPage,
  // pageSize = Config.DEFAULTS.PAGE_SIZE,
  // onPageChanged,
  children,
  sort,
  onRowClick,
  editCollection,
}) => {
  const key = keyField || '_id';

  const dataColumns = [];
  const linkColumns = [];
  const dbColumnNames = [];
  let paging = null;

  const { state: auth } = useContext(AuthContext);

  const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [editingFields, setEditingFields] = useState([]);
  const editingFieldsValues = useRef({}).current;
  const [savingEdits, setSavingEdits] = useState([]);

  const openDeleteConfirmation = (item, linkColumnProps) => {
    setSelectedItem({ dataItem: item, linkColumnProps });
    setIsDeleteConfirmationOpen(true);
  };

  const closeDeleteConfirmation = () => {
    setIsDeleteConfirmationOpen(false);
  };

  React.Children.map(children, (child) => {
    if (child && child.props.__TYPE === 'DataColumn') {
      dataColumns.push({ ...child.props });

      if (child.props.dbColumnName) {
        dbColumnNames.push({
          name: child.props.dbColumnName,
          className: child.props.dataCellClass,
          renderClass: child.props.renderDataCellClass,
          onClick: child.props.onClick,
          editSettings: child.props.editSettings,
        });
      }
    }

    if (child && child.props.__TYPE === 'LinkColumn') {
      linkColumns.push({ ...child.props });
    }

    if (child && child.props.__TYPE === 'Paging') {
      paging = { ...child.props };
    }
  });

  const findMatchingColumn = (columns, dbColumnName) => {
    if (columns && columns.length > 0) {
      for (const column of columns) {
        if (column.dbColumnName === dbColumnName) {
          return column;
        }
      }
    }

    return null;
  };

  const renderDataCell = (dbColumn, data, rowInd) => {
    const matchingHeaderColumn = findMatchingColumn(dataColumns, dbColumn.name);

    if (matchingHeaderColumn) {
      try {
        return matchingHeaderColumn.render(data, rowInd);
      } catch (e) {
        const result = data[dbColumn.name];

        if (result === true) {
          return <CheckCircleIcon className="h-5 w-5" aria-hidden="true" />;
        }

        return result;
      }
    }

    return data[dbColumn.name];
  };

  const saveEditedValues = async (valueField, dbField) => {
    if (!editCollection || !editingFieldsValues[valueField] || Object.keys(editingFieldsValues[valueField]).length === 0) {
      return;
    }

    setSavingEdits((prev) => ([...prev, dbField]));

    const groupedArray = Object.entries(editingFieldsValues[valueField])
      .reduce((result, [id, value]) => {
        const group = result.find((item) => item.value === value);

        if (group) {
          group.ids.push(id);
        } else {
          result.push({ ids: [id], value });
        }

        return result;
      }, []);

    // eslint-disable-next-line guard-for-in
    for (const groupItem of groupedArray) {
      const itemIds = groupItem.ids;
      const itemValue = groupItem.value;

      if (!itemIds || itemIds.length === 0) {
        return;
      }

      // eslint-disable-next-line no-await-in-loop
      // await db.updateManyRecords({
      //   collectionName: editCollection,
      //   database: Config.CODEMASH.DATABASE_ID,
      //   filter: { _id: { $in: itemIds.map((x) => ({ $oid: x })) } },
      //   update: { $set: { [dbField]: itemValue } },
      //   secretKey: auth.token,
      //   ignoreTriggers: true,
      // });

      // eslint-disable-next-line no-await-in-loop
      await resourceRequest({
        data: {
          resource: editCollection,
          filter: JSON.stringify({ _id: { $in: itemIds.map((x) => ({ $oid: x })) } }),
          updateType: `${editCollection}_${dbField}`,
          data: { [dbField]: itemValue },
        },
        action: 'updateMany',
      });

      const listItems = source.filter((x) => itemIds.includes(x._id));

      if (listItems && listItems.length > 0) {
        listItems.forEach((listItem) => {
          // eslint-disable-next-line no-param-reassign
          listItem[valueField] = itemValue;
        });
      }
    }

    delete editingFieldsValues[valueField];

    setSavingEdits((prev) => ([...prev.filter((x) => x !== dbField)]));
  };

  return (
    <>
      <div className="mt-8 overflow-x-auto shadow ring-1 ring-black ring-opacity-5 md:mx-0 md:rounded-lg">
        <table className="min-w-full divide-y divide-gray-300">
          <thead className="bg-gray-50">
            <tr>
              {dataColumns.map((dataColumnProps) => (
                <DataColumn
                  key={`hdc_${dataColumnProps.dbColumnName}`}
                  {...dataColumnProps}
                  sort={sort}
                  onEdit={(valueField, dbField) => {
                    if (editingFields.includes(valueField)) {
                      saveEditedValues(valueField, dbField);
                    }

                    setEditingFields((prev) => {
                      if (prev.includes(valueField)) {
                        return [...prev.filter((x) => x !== valueField)];
                      }

                      return [...prev, valueField];
                    });
                  }}
                  isEditing={dataColumnProps.editSettings && editingFields.includes(dataColumnProps.editSettings.valueField)}
                  isSavingEdit={dataColumnProps.editSettings && savingEdits.includes(dataColumnProps.editSettings.dbField)}
                />
              ))}
              {linkColumns.map((linkColumnProps, index) => (
                <LinkColumn key={`hlc_${index}`} {...linkColumnProps} renderForHeader />
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {source?.map((sourceItem, rowInd) => (
              <tr
                key={key === '_index' ? rowInd : sourceItem[key]}
                // eslint-disable-next-line no-nested-ternary
                onClick={editingFields && editingFields.length > 0 ? undefined : onRowClick ? (e) => onRowClick(sourceItem, rowInd, e) : undefined}
                className={`${onRowClick ? 'cursor-pointer hover:bg-gray-50' : ''}`}
              >
                {dbColumnNames.map((dbColumn) => {
                  const isEditingThisField = dbColumn.editSettings && editingFields.includes(dbColumn.editSettings.valueField);

                  if (isEditingThisField) {
                    return (
                      <td
                        key={`dc_${dbColumn.name}`}
                        className={`${dbColumn.className} ${dbColumn.renderClass ? dbColumn.renderClass(sourceItem) : ''}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                        }}
                      >
                        <EditDataColumn
                          item={sourceItem}
                          editSettings={dbColumn.editSettings}
                          onEdit={(value) => {
                            if (!editingFieldsValues[dbColumn.editSettings.dbField]) {
                              editingFieldsValues[dbColumn.editSettings.dbField] = {};
                            }

                            editingFieldsValues[dbColumn.editSettings.dbField][sourceItem._id] = value;
                          }}
                        />
                      </td>
                    );
                  }

                  const matchingHeaderColumn = findMatchingColumn(dataColumns, dbColumn.name);

                  return (
                    <td
                      key={`dc_${dbColumn.name}`}
                      className={`${dbColumn.className} ${dbColumn.renderClass ? dbColumn.renderClass(sourceItem) : ''}`}
                      onClick={dbColumn.onClick ? (e) => dbColumn.onClick(e, sourceItem, rowInd) : undefined}
                    >
                      {renderDataCell(dbColumn, sourceItem, rowInd)}
                      {!!matchingHeaderColumn.stackedColumns && (
                      <dl className="font-normal">
                        {matchingHeaderColumn.stackedColumns.map((x) => {
                          return (
                            <dd key={x.name} className={x.class}>{x.render
                              ? x.render(sourceItem, rowInd)
                              : sourceItem[x.dbColumnName]}
                            </dd>
                          );
                        })}
                      </dl>
                      )}
                    </td>
                  );
                })}
                {linkColumns.map((linkColumnProps, index) => (
                  <LinkColumn
                    {...linkColumnProps}
                    title={linkColumnProps.titleFunc ? linkColumnProps.titleFunc(rowInd) : linkColumnProps.title}
                    key={`ec_${sourceItem[key]}_${index}`}
                    onClick={() => {
                      if (
                        linkColumnProps.askForConfirmation &&
                        typeof linkColumnProps.askForConfirmation === 'boolean'
                      ) {
                        openDeleteConfirmation(sourceItem, linkColumnProps);
                      } else {
                        linkColumnProps.onClick(sourceItem, rowInd);
                      }
                    }}
                    renderForHeader={false}
                  />
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {paging && <Pagination {...paging} />}
      <ConfirmationDialog
        type={ConfirmationDialogTypes.DELETE}
        item={selectedItem}
        isOpen={isDeleteConfirmationOpen}
        closeModal={closeDeleteConfirmation}
      />
    </>
  );
};
